module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
// module id = 3
// module chunks = 0 1